export const FLUXOGRAM_NODE_CLASS = 'klickbox-fluxogram';



/** WEBPACK FOOTER **
 ** ./src/helpers/fluxogram/config/markup.js
 **/